module.exports = __webpack_public_path__ + "img/train2-outside.9d403de8.png";